import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.maxDepth = 0
    this.firedDepths = new Set()

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })

    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  ctaClicked(event) {
    const ctaLocation = event?.params?.ctaLocation || "unknown"
    this.capture("landing_cta_clicked", { cta_location: ctaLocation })
  }

  onScroll() {
    const doc = document.documentElement
    const scrollTop = window.scrollY || doc.scrollTop || 0
    const viewportHeight = window.innerHeight || doc.clientHeight || 0
    const scrollHeight = doc.scrollHeight || 0

    const depth = Math.min(100, Math.max(0, Math.round(((scrollTop + viewportHeight) / scrollHeight) * 100)))
    this.maxDepth = Math.max(this.maxDepth, depth)

    ;[25, 50, 75, 100].forEach((threshold) => {
      if (this.firedDepths.has(threshold)) return
      if (this.maxDepth < threshold) return

      this.firedDepths.add(threshold)
      this.capture("landing_scroll_depth", { depth: threshold })
    })
  }

  capture(event, properties = {}) {
    if (typeof window === "undefined") return
    if (!window.posthog || typeof window.posthog.capture !== "function") return

    window.posthog.capture(event, properties)
  }
}

